import React from 'react';
import { Card, Table, Button } from 'react-bootstrap';
import { PlusOutlined } from '@ant-design/icons';
import { BAC_DAO_TAO } from '@app/utils/define';
import { RenderFileMinhChung, RenderActionButtons } from './HelperComponents';

const EducationAndLanguage = ({
    printVersion,
    quaTrinhDaoTao,
    ngoaiNgu,
    isAdmin,
    setSelectedItem,
    setActiveModal,
    handleDeleteItem,
    handleApprove,
    openRejectModal
}) => {
    return (
        <>
            {/* QUÁ TRÌNH ĐÀO TẠO */}
            <Card className={`shadow-sm border-0 mb-4 ${printVersion === 'v2' ? 'd-print-none' : ''}`}>
                <Card.Header className="bg-white border-bottom-0 pt-4 pb-0 d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold mb-0 text-secondary">
                        <i className="fas fa-book-reader mr-2 text-primary" />1. Quá trình đào tạo (Đại học & Sau đại học)
                    </h5>
                    <Button 
                        size="sm" 
                        variant="outline-primary" 
                        onClick={() => { setSelectedItem({}); setActiveModal('DaoTao'); }} 
                        className="d-print-none"
                    >
                        <PlusOutlined /> Thêm bậc học
                    </Button>
                </Card.Header>
                <Card.Body>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>Bậc đào tạo</th>
                                <th>Trường / Cơ sở đào tạo</th>
                                <th>Chuyên ngành</th>
                                <th>Năm tốt nghiệp</th>
                                <th className="d-print-none">Minh chứng</th>
                                <th className="d-print-none">Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {quaTrinhDaoTao.map(d => (
                                <tr key={d.id}>
                                    <td><strong>{BAC_DAO_TAO.find(o => o.value === d.bacDaoTao)?.label || d.bacDaoTao}</strong></td>
                                    <td>{d.truongDaoTao}</td>
                                    <td>{d.chuyenNganh}</td>
                                    <td>{d.namTotNghiep}</td>
                                    <td className="d-print-none">
                                        <RenderFileMinhChung jsonString={d.fileMinhChung} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderActionButtons 
                                            type="DaoTao" 
                                            item={d}
                                            isAdmin={isAdmin}
                                            setSelectedItem={setSelectedItem}
                                            setActiveModal={setActiveModal}
                                            handleDeleteItem={handleDeleteItem}
                                            handleApprove={handleApprove}
                                            openRejectModal={openRejectModal}
                                        />
                                    </td>
                                </tr>
                            ))}
                            {quaTrinhDaoTao.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">Chưa khai báo quá trình đào tạo</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* NGOẠI NGỮ */}
            <Card className={`shadow-sm border-0 ${printVersion === 'v2' ? 'd-print-none' : ''}`}>
                <Card.Header className="bg-white border-bottom-0 pt-4 pb-0 d-flex justify-content-between align-items-center">
                    <h5 className="font-weight-bold mb-0 text-secondary">
                        <i className="fas fa-language mr-2 text-primary" />2. Chứng chỉ ngoại ngữ
                    </h5>
                    <Button 
                        size="sm" 
                        variant="outline-primary" 
                        onClick={() => { setSelectedItem({}); setActiveModal('NgoaiNgu'); }} 
                        className="d-print-none"
                    >
                        <PlusOutlined /> Thêm ngoại ngữ
                    </Button>
                </Card.Header>
                <Card.Body>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>Tên bằng / Chứng chỉ</th>
                                <th>Mức độ</th>
                                <th>Nơi cấp</th>
                                <th>Thời gian được cấp</th>
                                <th className="d-print-none">Minh chứng</th>
                                <th className="d-print-none">Thao tác</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ngoaiNgu.map(n => (
                                <tr key={n.id}>
                                    <td><strong>{n.tenNgoaiNgu}</strong></td>
                                    <td>{n.mucDo}</td>
                                    <td>{n.noiCap}</td>
                                    <td>{n.thoiGianCap}</td>
                                    <td className="d-print-none">
                                        <RenderFileMinhChung jsonString={n.fileMinhChung} />
                                    </td>
                                    <td className="d-print-none">
                                        <RenderActionButtons 
                                            type="NgoaiNgu" 
                                            item={n}
                                            isAdmin={isAdmin}
                                            setSelectedItem={setSelectedItem}
                                            setActiveModal={setActiveModal}
                                            handleDeleteItem={handleDeleteItem}
                                            handleApprove={handleApprove}
                                            openRejectModal={openRejectModal}
                                        />
                                    </td>
                                </tr>
                            ))}
                            {ngoaiNgu.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">Chưa khai báo ngoại ngữ</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    );
};

export default EducationAndLanguage;
